import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { environment } from '../../../../environments/environment';
import { copyToClipboard } from '../../../helpers/copyToClipboard';
import { ChatService } from '../../../services/chat.service';
import { TutorService } from '../../../services/tutor.service';
import { UsageService } from '../../../services/usage.service';

@Component({
  selector: 'app-embedding-dialog',
  templateUrl: './embedding-dialog.component.html',
  styleUrl: './embedding-dialog.component.scss',
})
export class EmbeddingDialogComponent implements OnInit {
  @Input() apiKey!: string;
  @Input() botId!: string;

  form: FormGroup;

  constructor(
    protected dialogRef: NbDialogRef<EmbeddingDialogComponent>,
    protected nbToastrService: NbToastrService,
    protected usageService: UsageService,
    protected tutorService: TutorService,
    protected chatService: ChatService,
    protected fb: FormBuilder
  ) {
    this.form = this.fb.group({
      apiKey: ['', Validators.required],
      botId: ['', [Validators.required]],
      codeSnippet: [''],
    });

    this.usageService.listApiKeys().subscribe();
    this.tutorService.listTutors().subscribe();
    this.chatService.listChatSettings().subscribe();
  }

  ngOnInit() {
    if (this.apiKey || this.botId) {
      this.form.patchValue({
        apiKey: this.apiKey,
        botId: this.botId,
      });
    }
  }

  get scriptTag() {
    if (!this.form.value.apiKey || !this.form.value.botId) {
      return '';
    }

    const chatSettings = this.chatService.chatSettings$.value.find(
      (setting) => setting.id === this.form.value.botId
    );

    const primaryColor = chatSettings?.styles?.primaryColor || '#72AECF';

    return `<script>var e=document,t=e.createElement("script");t.src="${environment.chatWidgetUrl}",t.onload=function(){_loadAlChat({apiKey:"${this.form.value.apiKey}",botId:"${this.form.value.botId}"})},e.body.appendChild(t);</script>`;
  }

  copyToClipboard() {
    copyToClipboard(this.scriptTag);

    this.nbToastrService.success(
      'Einbettungscode in die Zwischenablage kopiert.',
      'Kopiert!'
    );
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }
}
